<template>
  <div :class="className">
    <canvas ref="canvas"></canvas>
  </div>
</template>

<script>
import QRCode from 'qrcode'

export default {
  props: {
    text: {
      type: String,
      required: true,
    },
    className: {
      type: String,
      required: true,
    },
    icon: {
      type: String,
      required: false,
    },
  },
  methods: {
    generateQRCode() {
      const canvas = this.$refs.canvas
      const parent = canvas.parentElement
      const width = parent.clientWidth

      QRCode.toCanvas(canvas, this.text, {
        width,
        version: 8,
      })
        .then(() => {
          if (this.icon) {
            const iconImage = new Image()
            iconImage.src = this.icon
            const ctx = canvas.getContext('2d')
            iconImage.onload = () => {
              const iconSize = width / 5 // 图标尺寸占二维码的1/5
              const x = (canvas.width - iconSize) / 2
              const y = (canvas.height - iconSize) / 2

              ctx.drawImage(iconImage, x, y, iconSize, iconSize)
            }
          }
        })
        .catch((err) => {
          console.error(err)
        })
    },
  },
  watch: {
    text() {
      this.generateQRCode()
    },
  },
  mounted() {
    this.generateQRCode()
  },
}
</script>
